import React, { Component } from 'react'
import ContMessageI18N from '../../containers/ContMessageI18N';
import HelperEnv from '../../helpers/HelperEnv';

class FinanceFileSetting extends Component {

	constructor(props) {
		super(props);
		var username = this.props.data ? this.props.data.username : null;
		var password = this.props.data ? this.props.data.password : null;
		this.state = {
			username: username,
			password: password
		}

	}

	handleValid = () => {
		if (this.isSubmittable()) {
			let isFinanceFile = false;
			if (!(this.props.isAuthSimu || HelperEnv.getEnabledConditionTestVehicles() === 'authenticated')) {
				isFinanceFile = true;
			}
			this.props.onChange(this.state.username, this.state.password, isFinanceFile);
		}
	};

	handleChange = name => event => {
		var newValue = event.target.value;
		this.setState({ [name]: newValue })
	};

	isSubmittable = () => {
		return !this.props.isAuthSimu || (this.state.username != null && this.state.password != null && this.state.username.length !== 0 && this.state.password.length !== 0);
	}

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	onKeyDown = (event) => {
		if (event.keyCode === 13) {
			this.handleValid();
			document.getElementById('authentModal').style.display = 'none';
			const n = document.querySelector('.modal-backdrop');
			n.remove();
			document.body.style = null;
			document.body.setAttribute('data-bs-overflow',undefined);
			document.body.setAttribute('data-bs-padding-right',undefined);
			document.body.classList.remove("modal-open");
		}
	}

	render() {
		const username = this.state.username;
		const password = this.state.password;
		return (
			<React.Fragment>
				<div className="modal" id="authentModal" tabIndex="-1">
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-body" onKeyDown={this.onKeyDown}>
								<div>
									<div className="input-group mb-3">
										<span className="input-group-text" id="text-username">{this.getMessage('generics.username')}</span>
										<input type="text" className="form-control"
											aria-label={this.getMessage('generics.username')}
											aria-describedby="text-username"
											defaultValue={username}
											onChange={this.handleChange('username')}
										/>
									</div>
								</div>
								<div>
									<div className="input-group mb-3">
										<span className="input-group-text" id="text-password">{this.getMessage('generics.password')}</span>
										<input type="password" className="form-control"
											aria-label={this.getMessage('generics.password')}
											aria-describedby="text-password"
											defaultValue={password}
											onChange={this.handleChange('password')}
										/>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-primary"
									onClick={() => this.handleValid()} disabled={!this.isSubmittable()} data-bs-dismiss="modal">
									{this.getMessage('generics.ok')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default FinanceFileSetting

